<template>
  <section id="FindVej" class="section">
    <div class="section-header js-section-header">
      <h2>Find Vej</h2>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <img src="/img/map.png" class="img-fluid">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "MAP"
};
</script>

<style lang="scss" scoped>
.section {
  background-image: linear-gradient(#78d287, #65cc76);
}
</style>
